<template>
  <div class="staff-detail-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('staffDetailInfo.title') }}</span>
            <el-button style="padding: 3px 0" type="text" @click="goBack">
              {{ $t('common.back') }}
            </el-button>
          </div>
          <div class="staff-info">
            <el-row :gutter="20">
              <el-col :span="4">
                <el-image style="width: 120px; height: 140px; border-radius: 4px;" :src="staffDetailInfo.photoUrl"
                  fit="cover" @error="errorLoadImg">
                </el-image>
              </el-col>
              <el-col :span="20">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="info-item">
                      <label>{{ $t('staffDetailInfo.staffId') }}</label>
                      <div>{{ staffDetailInfo.staffId }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <label>{{ $t('staffDetailInfo.userName') }}</label>
                      <div>{{ staffDetailInfo.userName }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item ">
                      <label>{{ $t('staffDetailInfo.email') }}</label>
                      <div>{{ staffDetailInfo.email }}</div>
                    </div>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <div class="info-item">
                      <label>{{ $t('staffDetailInfo.tel') }}</label>
                      <div>{{ staffDetailInfo.tel }}</div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <label>{{ $t('staffDetailInfo.sex') }}</label>
                      <div>{{ staffDetailInfo.sex == '0' ? $t('staffDetailInfo.male') : $t('staffDetailInfo.female') }}
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="info-item">
                      <label>{{ $t('staffDetailInfo.address') }}</label>
                      <div>{{ staffDetailInfo.address }}</div>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-card>

        <el-card class="box-card margin-top text-left">
          <div slot="header" class="clearfix ">
            <span>{{ $t('staffDetailInfo.relatedOrg') }}</span>
          </div>
          <div v-for="(item, index) in staffDetailInfo.orgs" :key="index">
            <div class="org-item">{{ $t('staffDetailInfo.org') }}: {{ item.orgName }}</div>
          </div>
        </el-card>

        <el-card class="box-card margin-top text-left">
          <div slot="header" class="clearfix">
            <span>{{ $t('staffDetailInfo.relatedRoleCommunity') }}</span>
          </div>
          <div v-for="(item, index) in staffDetailInfo.roles" :key="index">
            <div class="flex justify-start">
             <div> {{ item.roleName }} </div> <div v-if="item.roleCommunityDtoList.length > 0">(
              <span v-for="(item1, index1) in item.roleCommunityDtoList" :key="index1">
                {{ item1.communityName }}
                {{ index1 === item.roleCommunityDtoList.length - 1 ? " " : " ?" }}
              </span> )
              </div>
            </div>
          </div>
        </el-card>

        <el-card class="box-card margin-top text-left">
          <div slot="header" class="clearfix">
            <span>绑定专业</span>
          </div>
          <div v-if="boundSkills.length > 0">
            <div v-for="(skill, index) in boundSkills" :key="index" class="flex justify-start">
              <div>{{ skill }}</div>
              <span v-if="index !== boundSkills.length - 1"> ?</span>
            </div>
          </div>
          <div v-else class="no-data">暂无绑定专业</div>
        </el-card>

        <!-- <staff-map-pos :staff-id="staffDetailInfo.staffId" class="margin-top"></staff-map-pos> -->
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getStaffDetail, getStaffOrgs, getStaffRoles, getStaffPrivileges } from '@/api/staff/staffDetailApi'
import { getUserCategorys } from '@/api/user/userInfoApi'
import { listRepairCategories } from '@/api/work/skillApi'

export default {
  name: 'StaffDetailList',
  components: {
  },
  data() {
    return {
      staffDetailInfo: {
        staffId: '',
        userName: '',
        email: '',
        tel: '',
        sex: '',
        address: '',
        photo: '',
        orgs: [],
        roles: []
      },
      privilegeTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'text'
      },
      boundSkills: [] // 绑定的技能名称列表
    }
  },
  created() {
    this.staffDetailInfo.staffId = this.$route.query.staffId
    this.loadStaffDetail()
    this.loadStaffOrgs()
    this.loadStaffRoles()
    this.loadStaffPrivileges()
    this.loadBoundSkills()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    errorLoadImg() {
      this.staffDetailInfo.photoUrl = "/img/noPhoto.jpg"
    },
    async loadStaffDetail() {
      try {
        const params = {
          page: 1,
          row: 1,
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffDetail(params)
        if ( res.staffs.length > 0) {
          Object.assign(this.staffDetailInfo, res.staffs[0])
          this.staffDetailInfo.photoUrl = res.staffs[0].photoUrl
        }
      } catch (error) {
        this.$message.error(this.$t('staffDetailInfo.fetchError'))
      }
    },
    async loadStaffOrgs() {
      try {
        const params = {
          page: 1,
          row: 1,
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffOrgs(params)
        if (res.code === 0) {
          this.staffDetailInfo.orgs = res.data
        }
      } catch (error) {
        this.$message.error(this.$t('staffDetailInfo.fetchOrgError'))
      }
    },
    async loadStaffRoles() {
      try {
        const params = {
          page: 1,
          row: 9999,
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffRoles(params)
        if (res.code == 0) {
          this.staffDetailInfo.roles = res.data
        }
      } catch (error) {
        this.$message.error(this.$t('staffDetailInfo.fetchRoleError'))
      }
    },
    async loadStaffPrivileges() {
      try {
        const params = {
          staffId: this.staffDetailInfo.staffId
        }
        const res = await getStaffPrivileges(params)
        if (res.datas && res.datas.length > 0) {
          this.privilegeTreeData = this.buildTreeData(res.datas)
        }
      } catch (error) {
        this.$message.error(this.$t('staffDetailInfo.fetchPrivilegeError'))
      }
    },
    buildTreeData(privileges) {
      const groupMap = {}

      privileges.forEach(item => {
        if (!groupMap[item.gId]) {
          groupMap[item.gId] = {
            id: `g_${item.gId}`,
            gId: item.gId,
            text: item.gName,
            children: []
          }
        }

        const group = groupMap[item.gId]
        const menuExists = group.children.some(menu => menu.mId === item.mId)

        if (!menuExists) {
          group.children.push({
            id: `m_${item.mId}`,
            mId: item.mId,
            text: item.mName,
            children: []
          })
        }

        const menu = group.children.find(menu => menu.mId === item.mId)
        menu.children.push({
          id: `p_${item.pId}`,
          pId: item.pId,
          text: item.pName
        })
      })

      return Object.values(groupMap)
    },
    async loadBoundSkills() {
      if (!this.staffDetailInfo.staffId) return
      
      try {
        // 获取员工已绑定的技能ID
        const res = await getUserCategorys({ userId: this.staffDetailInfo.staffId })
        
        let categoryIds = []
        if (res.data) {
          // 如果返回的数据中有 categoryNames，直接使用
          if (res.data.categoryNames && Array.isArray(res.data.categoryNames)) {
            this.boundSkills = res.data.categoryNames
            return
          }
          
          // 否则根据 categoryIds 或 categorys 获取ID
          if (res.data.categoryIds) {
            const ids = res.data.categoryIds
            categoryIds = typeof ids === 'string' 
              ? ids.split(',').filter(id => id.trim() !== '').map(id => id.trim())
              : (Array.isArray(ids) ? ids : [])
          } else if (res.data.categorys && Array.isArray(res.data.categorys)) {
            categoryIds = res.data.categorys
          }
        }
        
        if (categoryIds.length === 0) {
          this.boundSkills = []
          return
        }
        
        // 获取所有技能分类列表，用于匹配名称
        const { data: allCategories } = await listRepairCategories({ status: 1 })
        
        // 只获取一级分类
        const firstLevelCategories = allCategories.filter(
          item => item.categoryType == 1 || item.categoryType === '1'
        )
        
        // 根据ID匹配技能名称
        const skillNames = []
        categoryIds.forEach(id => {
          const category = firstLevelCategories.find(cat => 
            cat.id == id || cat.id === id || String(cat.id) === String(id)
          )
          if (category) {
            skillNames.push(category.name)
          }
        })
        
        this.boundSkills = skillNames
      } catch (error) {
        console.warn('获取绑定技能失', error)
        this.boundSkills = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.staff-detail-container {
  padding: 20px;

  .margin-top {
    margin-top: 20px;
  }

  .info-item {
    margin-bottom: 15px;


    label {
      display: block;
      color: #909399;
      margin-bottom: 5px;
    }
  }

  .org-item {
    padding: 5px 0;
  }

  .no-data {
    color: #909399;
    padding: 5px 0;
  }
}
</style>
